import { BrowserRouter, Route, Switch } from 'react-router-dom'
import {
  CONNECTS_API_SLUG,
  CONNECTS_API_V2_SLUG,
  NEXUS_API_SLUG,
  NEXUS_API_V2_SLUG,
  PAYMENTS_API_V2_SLUG
} from 'src/constants'
import { ThemeProvider, createTheme } from '@mui/material/styles'

import ConnectsAPIDocs from './ConnectsAPIDocs'
import ConnectsAPIV2Docs from './ConnectsAPIV2Docs'
import { ContextOptions } from '@frontegg/types/ContextOptions'
import { CssBaseline } from '@mui/material'
import { DevPortalProvider } from '@stoplight/elements-dev-portal'
import { FronteggProvider } from '@frontegg/react'
import { FunctionComponent } from 'react'
import Home from 'src/pages/Home'
import MigrationGuide from 'src/pages/MigrationGuide'
import NavBar from './NavBar'
import NexusAPIDocs from './NexusAPIDocs'
import NexusAPIV2Docs from './NexusAPIV2Docs'
import NotFound from 'src/pages/NotFound'
import PaymentsAPIV2Docs from './PaymentsAPIV2Docs'

const theme = createTheme({
  palette: {
    primary: {
      main: '#17859b'
    },
    secondary: {
      main: '#85d1f6'
    },
    error: {
      main: '#c5031d'
    },
    info: {
      main: '#17859b'
    },
    success: {
      main: '#72bd75'
    },
    warning: {
      main: '#ff9a07'
    },
    background: {
      default: '#F5F7FA'
    }
  },
  typography: {
    button: {
      textTransform: 'none'
    }
  }
})

const contextOptions: ContextOptions = {
  baseUrl: process.env.REACT_APP_FRONTEGG_BASE_URL || '',
  clientId: process.env.REACT_APP_FRONTEGG_CLIENT_ID || '',
  appId: process.env.REACT_APP_FRONTEGG_APP_ID || ''
}

const authOptions = {
  keepSessionAlive: true,
  hostedLoginOptions: {
    loadUserOnFirstLoad: true
  }
}

const App: FunctionComponent = () => {
  return (
    // @ts-ignore
    <DevPortalProvider>
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <FronteggProvider
            contextOptions={contextOptions}
            hostedLoginBox={true}
            authOptions={authOptions}
          >
            <NavBar />
            <Switch>
              <Route exact path="/" component={Home} />
              <Route path="/migrate-to-v2" component={MigrationGuide} />
              <Route path={`/${CONNECTS_API_SLUG}`} component={ConnectsAPIDocs} />
              <Route path={`/${NEXUS_API_SLUG}`} component={NexusAPIDocs} />
              <Route path={`/${CONNECTS_API_V2_SLUG}`} component={ConnectsAPIV2Docs} />
              <Route path={`/${NEXUS_API_V2_SLUG}`} component={NexusAPIV2Docs} />
              <Route path={`/${PAYMENTS_API_V2_SLUG}`} component={PaymentsAPIV2Docs} />
              <Route component={NotFound} />
            </Switch>
          </FronteggProvider>
        </ThemeProvider>
      </BrowserRouter>
    </DevPortalProvider>
  )
}

export default App
